import {Card, CardContent, CardHeader, Table, TableCell, TableRow, Typography} from "@mui/material";
import Loading from "../../components/Common/Loading";
import SimpleTable from "../../components/Common/Elements";
import {useGetRtEnvironmentsV1Query} from "../../core/api/roger-that-analytical-data-api";
import {useGetEnvironmentsV1TOHQuery} from "../../core/api/toh-analytical-data-api";
import {useGetEnvironmentsV1DSQuery} from "../../core/api/ds-analytical-data-api";
import {useGetEnvironmentsV1MCQuery} from "../../core/api/mc-analytical-data-api";


const TechInfoMC = (props) => {

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetEnvironmentsV1MCQuery(props.deviceId, 5)

    let info = ""

    console.log('props')
    console.log(props)

    const simple_view_cols = [
        'model', 'name', 'os', 'currentVersion', 'systemMemory', 'graphicsMemory', 'resolution',
        'lang','version','sessionVersion','timestamp'
    ]


    console.log(typeof data)
    if (typeof data === "object") {
        let techData = []
        for (const key in data[0]) {
            if (props.isSimple && simple_view_cols.indexOf(key) == -1) continue;
            techData.push([key, data[0][key]])
        }
        info = <SimpleTable data={techData}/>
    } else {
        info = "no data"
    }

    const getTable = () => {

        return <Card>
            {data.length}
            <Table>
                {data.map((item, key) => {
                    if(key != 0)
                        return <TableRow>
                            <TableCell>{JSON.stringify(item)}</TableCell>
                        </TableRow>
                })}
            </Table>
        </Card>
    }

    return (
        <Loading
            isLoading={isLoading}
            isError={isError}
            error={error}
            isSuccess={isSuccess}
        >

            <Card>
                <CardContent>
                    <Typography sx={{fontSize: 16}}>
                        Last device
                    </Typography>
                </CardContent>
                {info}
            </Card>


        </Loading>
    )
}

export default TechInfoMC